var customProductBuilder_selectedLogo = null;
var customProductBuilder_selectedLogoColor = null;
var customProductBuilder_totalPriceSet = {};
var customProductBuilder_productProperties = {};
var customProductBuilder_selectedFile = null;
var customProductBuilder_seatDriverFile = null;
var customProductBuilder_seatPassengerFile = null;

// run at startup
document.addEventListener("DOMContentLoaded", () => {
    customProductBuilder_init();

    // register buy button
    customProductBuilder_registerBuyButton();
});

///////////////////////////////////////////////////////////

function customProductBuilder_init() {
    // reset arrays
    customProductBuilder_AccessoriesProducts = [{ id: 0 }];
    customProductBuilder_AccessoriesVariants = [];

    // check for additional properties
    const passengerSeat = document.querySelector("#customProductOption_passengerSeatProperty");
    if (passengerSeat) {
        customProductBuilder_productProperties.passengerSeat = {
            label: "Passenger Seat Type",
            value: passengerSeat.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(passengerSeat, "passengerSeat");
    }
    const heatingType = document.querySelector("#customProductOption_heatingTypeProperty");
    if (heatingType) {
        customProductBuilder_productProperties.heatingType = {
            label: "Heating Type",
            value: heatingType.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(heatingType, "heatingType");
    }
    const handbrakeType = document.querySelector("#customProductOption_HandbrakeTypeProperty");
    if (handbrakeType) {
        customProductBuilder_productProperties.handbrakeType = {
            label: "Handbrake Type",
            value: handbrakeType.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(handbrakeType, "handbrakeType");
    }
    const gearShifter = document.querySelector("#customProductOption_GearShifterProperty");
    if (gearShifter) {
        customProductBuilder_productProperties.gearShifter = {
            label: "Gear Shifter",
            value: gearShifter.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(gearShifter, "gearShifter");
    }

    // seat additional properties
    const middleMaterial = document.querySelector("#customProductOption_middleMaterialProperty");
    if (middleMaterial) {
        customProductBuilder_productProperties.middleMaterial = {
            label: "Middle Material",
            value: middleMaterial.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(middleMaterial, "middleMaterial");
    }

    // seat additional properties
    const middleColor = document.querySelector("#customProductOption_middleColorProperty");
    if (middleColor) {
        customProductBuilder_productProperties.middleColor = {
            label: "Middle Color",
            value: middleColor.querySelector(".custom-product-option-list-value-info")?.innerText
        };
        customProductBuilder_registerPropertyClick(middleColor, "middleColor");
    }

    // get logo & color data
    try {
        const dataEl = document.querySelector("#customProductBuilder_AccessoriesProductsJSONScript");
        const data = JSON.parse(dataEl.textContent);
        
        customProductBuilder_AccessoriesProducts.push(...data.customProductBuilder_AccessoriesProductsJSON);
        customProductBuilder_AccessoriesVariants.push(...data.customProductBuilder_AccessoriesVariantsJSON);
    } catch { }

    // hide product images of logos
    const logoImages = customProductBuilder_AccessoriesProducts.map(p => p.featured_image).filter(v => v !== undefined);
    document.querySelectorAll(".product__media-wrapper img").forEach(image => {
        const logoImage = logoImages.find(f => image.src?.includes(f));
        if (!logoImage) return;
        
        image.classList.add("customProductBuilder_LogoImage");
        //image.closest("li").style.display = "none";
    });

    // hide product images of middle seat color
    if (typeof customProductBuilder_SeatMiddleColorImgPrefix !== "undefined" && customProductBuilder_SeatMiddleColorImgPrefix) {
        customProductBuilder_seatMiddleColorResetImages();
        customProductBuilder_handleMiddleColorChange();
    }

    // get main product price
    const mainProductPrice = parseFloat(document.querySelector(".custom-product-option-summary-total-price")?.innerText || 0);
    customProductBuilder_totalPriceSet.mainProduct = mainProductPrice || 0;

    customProductBuilder_selectedLogo = null;
    customProductBuilder_selectedLogoColor = null;
    customProductBuilder_selectedFile = null;

    // setup main product variants
    for (const variant of document.querySelectorAll("#customProductBuilder_MainVariants .custom-product-option-list-value") || []) {
        customProductBuilder_setupMainProductDOM(variant);
    }

    // check if product contains variant, if it does not, remove it
    for (const parent of customProductBuilder_AccessoriesProducts) {
        if (parent.id > 0) {
            parent.variants = parent.variants.filter(variant => 
                customProductBuilder_AccessoriesVariants.some(v => v.id === variant.id)
            );
        }

        // set up DOM
        customProductBuilder_setupParentDOM(parent);
    }

    // setup seat uploads
    const seatDriverUpload = document.querySelector("#customProductBuilder_SeatDriverUpload");
    const seatPassengerUpload = document.querySelector("#customProductBuilder_SeatPassengerUpload");
    if (seatDriverUpload) {
        customProductBuilder_setupSeatClick("driver");
    }
    if (seatPassengerUpload) {
        customProductBuilder_setupSeatClick("passenger");
    }
    const customLogo = document.querySelector("#customProductOption_LogoAnchor");
    if ((seatDriverUpload || seatPassengerUpload) && customLogo) {
        customProductBuilder_setupParentDOM({id: -1});
    }
}

///////////////////////////////////////////////////////////

function customProductBuilder_setupSeatClick(type) {
    let seatInput = null;
    let seatEl = null;

    if (type === "driver") {
        seatInput = document.querySelector("#customProductSeatDriverUpload");
        seatEl = document.querySelector("#customProductBuilder_SeatDriverUpload");
    } else if (type === "passenger") {
        seatInput = document.querySelector("#customProductSeatPassengerUpload");
        seatEl = document.querySelector("#customProductBuilder_SeatPassengerUpload");
    }

    if (!seatInput || !seatEl) return;

    seatEl.addEventListener("click", function () {
        seatInput.value = "";
        seatInput.click();

        seatInput.onchange = null;

        seatInput.onchange = () => {
            if (!seatInput.files || seatInput.files.length === 0) {
                if (type === "driver") customProductBuilder_seatDriverFile = null;
                else if (type === "passenger") customProductBuilder_seatPassengerFile = null;
                seatEl.querySelector(".custom-product-option-list-value-main").style.borderColor = "#ff4d4d";
                return;
            }

            const MAX_FILE_SIZE = 10 * 1024 * 1024;
            const ALLOWED_TYPES = [
                "image/png",
                "image/jpeg",
                "application/pdf",
            ];
            const file = seatInput.files[0];

            if (!ALLOWED_TYPES.includes(file.type) || file.size > MAX_FILE_SIZE) {
                if (type === "driver") customProductBuilder_seatDriverFile = null;
                else if (type === "passenger") customProductBuilder_seatPassengerFile = null;
                seatEl.querySelector(".custom-product-option-list-value-main").style.borderColor = "#ff4d4d";
                return;
            }

            if (type === "driver") customProductBuilder_seatDriverFile = seatInput.files[0];
            else if (type === "passenger") customProductBuilder_seatPassengerFile = seatInput.files[0];

            let image = document.querySelector("#customProductOption_EmptyUploadIcon svg");

            const newImg = document.createElement("img");
            newImg.className = "customProductOption_previewFile";
            if (type === "driver") newImg.src = URL.createObjectURL(customProductBuilder_seatDriverFile);
            else if (type === "passenger") newImg.src = URL.createObjectURL(customProductBuilder_seatPassengerFile);

            image = newImg;

            const temp = seatEl.querySelector(".custom-product-option-list-value-main");
            existingImg = temp.querySelector("svg") || temp.querySelector("img");
            existingImg.remove();
            temp.prepend(image);

            seatEl.querySelector(".custom-product-option-list-value-main").style.borderColor = "white";
        };
    });
}

function customProductBuilder_registerPropertyClick(property, propName) {
    property.querySelectorAll(".custom-product-option-list-value").forEach(option => {
        option.addEventListener("click", function (e) {
            // clear selection
            property.querySelectorAll(".custom-product-option-list-value-main.selected").forEach(p => {
                p.classList.remove("selected");
            });

            // update value
            customProductBuilder_productProperties[propName].value = option.querySelector(".custom-product-option-list-value-info")?.innerText || null;
            if (propName === "middleColor") {
                customProductBuilder_handleMiddleColorChange();
            }

            // set selected
            option.querySelector(".custom-product-option-list-value-main").classList.add("selected");
        });
    });
}

function customProductBuilder_handleMiddleColorChange() {
    const mainColor = document.querySelector("#customProductBuilder_MainVariants .custom-product-option-list-value-main.selected .custom-product-option-list-value-info")?.innerText;
    const middleColor = customProductBuilder_productProperties["middleColor"].value;

    customProductBuilder_seatMiddleColorResetImages();

    if (mainColor && middleColor) {
        // find matching image
        let matchingImage = null;
        const lookingForFileName = `${customProductBuilder_SeatMiddleColorImgPrefix}-mc_${mainColor.toLowerCase()}-cc_${middleColor.toLowerCase()}`;

        const allImages = document.querySelectorAll("media-gallery .product__media.media img");
        for (const image of allImages) {
            if (image.src.includes(lookingForFileName)) {
                matchingImage = image;
                break;
            }
        }

        if (!matchingImage) {
            customProductBuilder_seatMiddleColorResetImages();
            return;
        }

        const item = matchingImage.closest("li");
        if (!item) {
            customProductBuilder_seatMiddleColorResetImages();
            return;
        }
        
        const gallery = item.closest("ul");
        if (!gallery) {
            customProductBuilder_seatMiddleColorResetImages();
            return;
        }

        gallery.prepend(item);
        item.classList.remove("customProductBuilder_SeatMiddleColorImageHidden")
    }
}

function customProductBuilder_seatMiddleColorResetImages() {
    document.querySelectorAll("media-gallery .product__media.media img").forEach(img => {
        if (img.src.includes(customProductBuilder_SeatMiddleColorImgPrefix)) {
            const item = img.closest("li");
            if (item) {
                item.classList.add("customProductBuilder_SeatMiddleColorImageHidden");
                
                const gallery = item.closest("ul");
                if (gallery) {
                    gallery.append(item);
                }
            }
        }
    });
}

function customProductBuilder_setupMainProductDOM(variant) {
    const variantID = variant.dataset.optionValueId;
    
    variant.addEventListener("click", function(e) {
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
                event: e,
                target: variant,
                selectedOptionValues: [variantID.toString()]
            },
        });
    });
}

function customProductBuilder_setupParentDOM(parent) {
    const parentDOM = document.querySelector(`.custom-product-option-list-value[data-product-id="${parent.id}"]`);
    if (!parentDOM) return;

    if (parent.variants?.length > 1) {
        // add arrow
        parentDOM.querySelector(".custom-product-option-list-value-expand").classList.add("visible");

        // generate subitems
        const wrapper = document.createElement("div");
        wrapper.classList.add("custom-product-option-list-value-children");

        for (variant of parent.variants) {
            // element
            const el = document.createElement("div");
            el.classList.add("custom-product-option-list-value-main");
            el.dataset.variantId = variant.id;

            // image
            const img = document.createElement("img");
            img.src = variant.featured_image.src;
            img.width = 120;
            img.style.width = "120px";
            img.height = 120;
            img.style.height = "120px";
            el.appendChild(img);

            // info
            const info = document.createElement("div");
            info.classList.add("custom-product-option-list-value-info");
            
            // info > title
            const title = document.createElement("h5");
            title.innerText = variant.title;
            info.appendChild(title);

            // info > price
            const price = document.createElement("h6");
            price.innerText = customProductBuilder_formatPrice(variant.price);
            info.appendChild(price);

            el.appendChild(info);

            // color click listener
            el.addEventListener("click", function (e) {
                customProductBuilder_selectedLogoColor = customProductBuilder_selectedLogo.variants.find(v => v.id == el.dataset.variantId);

                wrapper.querySelectorAll(".custom-product-option-list-value-main").forEach(child => {
                    child.classList.remove("selected");
                });

                el.classList.add("selected");

                customProductBuilder_selectLogoColor();
            });

            wrapper.appendChild(el);
        }

        parentDOM.appendChild(wrapper);
    } else if (parent.variants?.length == 1) {
        parentDOM.querySelector("img").src = parent.variants[0].featured_image.src;
    }

    // setup click
    parentDOM.querySelector(".custom-product-option-list-value-main")?.addEventListener("click", function (e) {
        // custom upload
        if (parent.id === -1 || parent.id === -2) {
            const input = document.querySelector("#customProductOptionUpload");
            input.value = "";
            input.click();

            input.onchange = null;

            input.onchange = () => {
                if (!input.files || input.files.length === 0) {
                    customProductBuilder_selectedFile = null;
                }

                const MAX_FILE_SIZE = 10 * 1024 * 1024;
                const ALLOWED_TYPES = [
                    "image/png",
                    "image/jpeg",
                    "application/pdf",
                    "image/svg+xml",
                    "application/postscript",
                    "application/vnd.adobe.illustrator"
                ];
                const file = input.files[0];

                if (!ALLOWED_TYPES.includes(file.type) || file.size > MAX_FILE_SIZE) {
                    customProductBuilder_selectedFile = null;
                }

                customProductBuilder_selectedFile = input.files[0];

                customProductBuilder_customLogoUploaded(parent);
            };

            return;
        }

        customProductBuilder_selectedFile = null;
        customProductBuilder_clearCustomLogoPreview();

        const isSelected = parentDOM.querySelector(".custom-product-option-list-value-main").classList.contains("selected");
        const areChildrenExpanded = parentDOM.querySelectorAll(".custom-product-option-list-value-children")[0]?.style?.height != "0px";
        const isAlreadyExpanded = isSelected && areChildrenExpanded;

        // show image in main gallery
        document.querySelectorAll(".product__media-wrapper img").forEach(image => {
            const logoImage = image.src?.includes(parent.featured_image);

            if (image.classList.contains("customProductBuilder_LogoImage")) {
                image.closest("li").style.display = "none";
            }

            if (!logoImage) return;
            
            image.closest("li").style.display = "block";
        });

        let isSelectedLogoExpanding = false;

        if (parent.id === 0) {
            customProductBuilder_selectedLogo = null;
            customProductBuilder_selectedLogoColor = null;
        } else if (!isAlreadyExpanded) {
            if (isSelected && customProductBuilder_selectedLogo?.id === parent.id) isSelectedLogoExpanding = true;

            customProductBuilder_selectedLogo = parent;

            if (!isSelectedLogoExpanding) {
                customProductBuilder_selectedLogoColor = parent.variants[0];
            }
        }

        // hide other children
        parentDOM.parentElement.querySelectorAll(".custom-product-option-list-value-children").forEach(el => {
            el.style.height = 0;
        });

        parentDOM.parentElement.querySelectorAll(".custom-product-option-list-value-main.selected").forEach(el => {
            el.classList.remove("selected");
        });
        parentDOM.querySelector(".custom-product-option-list-value-main").classList.add("selected");

        if (parent.variants?.length > 1 && !isAlreadyExpanded) {
            // expand children
            const children = parentDOM.querySelector(".custom-product-option-list-value-children");
            if (children) {
                children.style.height = children.scrollHeight + "px";

                 if (!isSelectedLogoExpanding) {
                    // unselect all children
                    children.querySelectorAll(".custom-product-option-list-value-main").forEach(el => {
                        el.classList.remove("selected");
                    });
                }

                // select first (or selected) child
                children.querySelector(`.custom-product-option-list-value-main[data-variant-id="${customProductBuilder_selectedLogoColor.id}"]`).classList.add("selected");
            }
        }

        if (!isAlreadyExpanded) {
            customProductBuilder_selectLogoColor();
        }

        setTimeout(() => {
            document.querySelector("#customProductOption_LogoAnchor").scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 10);
    });
}

function customProductBuilder_customLogoUploaded(parent) {
    customProductBuilder_clearCustomLogoPreview();

    customProductBuilder_selectedLogo = parent;
    customProductBuilder_selectedLogoColor = null;

    const parentDOM = document.querySelector(`.custom-product-option-list-value[data-product-id="${parent.id}"]`);

    // hide other children
    parentDOM.parentElement.querySelectorAll(".custom-product-option-list-value-children").forEach(el => {
        el.style.height = 0;
    });

    parentDOM.parentElement.querySelectorAll(".custom-product-option-list-value-main.selected").forEach(el => {
        el.classList.remove("selected");
    });
    parentDOM.querySelector(".custom-product-option-list-value-main").classList.add("selected");

    // change image
    const allowedMimeTypes = [
        "image/jpeg",
        "image/png",
        "image/svg+xml"
    ];
    let image = document.querySelector("#customProductOption_EmptyUploadIcon svg");
    if (allowedMimeTypes.includes(customProductBuilder_selectedFile.type)) {
        const newImg = document.createElement("img");
        newImg.className = "customProductOption_previewFile";
        newImg.src = URL.createObjectURL(customProductBuilder_selectedFile);

        image = newImg;
    }

    const temp = parentDOM.querySelector(".custom-product-option-list-value-main");
    existingImg = temp.querySelector("svg") || temp.querySelector("img");
    existingImg.remove();
    temp.prepend(image);

    customProductBuilder_selectLogoColor(parent.id);
}

function customProductBuilder_clearCustomLogoPreview() {
    const defaultImg = document.querySelector("#customProductOption_EmptyUploadIcon svg");
    if (!defaultImg) return;

    const preview = document.querySelector(".customProductOption_previewFile");
    const parent = preview?.parentElement;
    preview?.remove();

    const clone = defaultImg?.cloneNode(true);

    parent?.prepend(clone);
}

function customProductBuilder_registerBuyButton() {
    try {
        if (customProductBuilder_SectionID == undefined) return;
    } catch {
        return;
    }

    const addToCartButton = document.querySelector(`#ProductSubmitButton-${customProductBuilder_SectionID}`);
    
    if (addToCartButton) {
        const form = document.querySelector(`#${customProductBuilder_FormID}`);
        if (!form) return;

        addToCartButton.addEventListener("click", async function (e) {
            e.preventDefault();
            
            const customGroupHash = Math.random().toString(36).slice(2,7);

            const fd = new FormData();
            let itemIndex = 0;

            // main product
            const mainProductId = form.querySelector("input[name='items[0][id]']").value;
            fd.append(`items[${itemIndex}][id]`, mainProductId);
            fd.append(`items[${itemIndex}][quantity]`, 1);
            fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);
            
            // apply properties to main product
            for (const [key, value] of Object.entries(customProductBuilder_productProperties)) { 
                fd.append(`items[${itemIndex}][properties][${value.label}]`, value.value);
            }

            // order note
            const orderNote = document.querySelector(`#tti-note-${customProductBuilder_SectionID}`);
            if (orderNote && orderNote.value) {
                fd.append(`items[${itemIndex}][properties][Additional wishes / questions]`, orderNote.value);
            }

            itemIndex++;

            // seat pictures
            const seatDriverUpload = document.querySelector("#customProductBuilder_SeatDriverUpload");
            const seatPassengerUpload = document.querySelector("#customProductBuilder_SeatPassengerUpload");

            // logo
            if (customProductBuilder_selectedLogo && !seatDriverUpload && !seatPassengerUpload) {
                if ((customProductBuilder_selectedLogo.id === -1 || customProductBuilder_selectedLogo.id === -2) && customProductBuilder_selectedFile) {
                    const variantID = customProductBuilder_selectedLogo.actualVariant.id;

                    fd.append(`items[${itemIndex}][id]`, variantID);
                    fd.append(`items[${itemIndex}][quantity]`, 1);

                    fd.append(
                        `items[${itemIndex}][properties][File Upload]`,
                        customProductBuilder_selectedFile
                    );
                    fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);

                    itemIndex++;
                } else {
                    const selectedVariant = customProductBuilder_selectedLogoColor.id || customProductBuilder_selectedLogo.variants[0].id;
                
                    fd.append(`items[${itemIndex}][id]`, selectedVariant);
                    fd.append(`items[${itemIndex}][quantity]`, 1);
                    fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);

                    itemIndex++;
                }
            }

            // seat pictures
            if (seatDriverUpload) {
                if (!customProductBuilder_seatDriverFile) {
                    setTimeout(() => {
                        document.querySelector("#customProductOption_LogoAnchor").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }, 10);
                    return;
                }

                fd.append(`items[0][properties][Driver Seat]`, customProductBuilder_seatDriverFile);
            }
            if (seatPassengerUpload) {
                if (!customProductBuilder_seatDriverFile) {
                    setTimeout(() => {
                        document.querySelector("#customProductOption_LogoAnchor").scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }, 10);
                    return;
                }

                fd.append(`items[0][properties][Passenger Seat]`, customProductBuilder_seatPassengerFile);
            }
            const seatCustomLogo = document.querySelector("#customProductOption_LogoAnchor");
            if ((seatDriverUpload || seatPassengerUpload) && seatCustomLogo && customProductBuilder_selectedFile) {
                fd.append(`items[0][properties][Custom Logo]`, customProductBuilder_selectedFile);
            }

            const sections = [
                "cart-notification-product",
                "cart-notification-button",
                "cart-icon-bubble"
            ];
            const sectionsUrl = window.location.pathname;

            const response = await fetch(`/cart/add.js?sections=${sections.join(',')}&sections_url=${encodeURIComponent(sectionsUrl)}`, {
                method: "POST",
                body: fd
            });

            const cartResponse = await response.json();

            // extract key
            const keyHTML = cartResponse.sections["cart-notification-product"];
            const keyMatch = keyHTML.match(/id="cart-notification-product-([^"]+)"/);

            const key = keyMatch[1];

            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainProductId,
                cartData: cartResponse
            });
            CartPerformance.measure("add:paint-updated-sections", () => {
                cartResponse.key = key;
                cart.renderContents(cartResponse);
            });
        });
    }
}

function customProductBuilder_selectLogoColor(customLogoID) {
    const seatDriverUpload = document.querySelector("#customProductBuilder_SeatDriverUpload");
    const seatPassengerUpload = document.querySelector("#customProductBuilder_SeatPassengerUpload");
    if (seatDriverUpload || seatPassengerUpload) return;

    // remove old logo
    document.querySelector(".custom-product-option-summary-list .custom-product-option-summary-item.logo")?.remove();

    const list = document.querySelector(".custom-product-option-summary-list");
    const total = document.querySelector(".custom-product-option-summary-total-price");
    if (!list || !total) return;

    if (customProductBuilder_selectedLogo && (customProductBuilder_selectedLogoColor || customLogoID)) {
        const tempLogoColor = customProductBuilder_selectedLogoColor || customProductBuilder_AccessoriesProducts.find(f => f.id === customLogoID).actualVariant;

        // add new logo
        const newItem = document.createElement("div");
        newItem.classList.add("custom-product-option-summary-item");
        newItem.classList.add("logo");
        
        const name = document.createElement("div");
        name.classList.add("custom-product-option-summary-item-name");
        
        const h5 = document.createElement("h5");
        h5.innerText = customProductBuilder_selectedLogo.title || (customLogoID === -1 ? "Your Embroidered Logo" : "Your Quilted Logo");
        name.appendChild(h5);
    
        const h6 = document.createElement("h6");
        h6.innerText = tempLogoColor.title == "Default Title" ? "" : tempLogoColor.title;
        name.appendChild(h6);
    
        newItem.appendChild(name);
    
        const price = document.createElement("div");
        price.classList.add("custom-product-option-summary-item-price");
        
        if (tempLogoColor.compare_at_price) {
            const priceSale = document.createElement("div");
            priceSale.classList.add("custom-product-option-summary-item-price-sale");
            if (tempLogoColor.compare_at_price) {
                priceSale.innerText = (customProductBuilder_formatPrice(tempLogoColor.compare_at_price));
            }
            price.appendChild(priceSale);
        }
    
        const priceRegular = document.createElement("span");
        priceRegular.innerText = (customProductBuilder_formatPrice(tempLogoColor.price));
        price.appendChild(priceRegular);
    
        newItem.appendChild(price);
    
        list.appendChild(newItem);
    
        // calculate new total
        customProductBuilder_totalPriceSet.logo = parseFloat(tempLogoColor.price) / 100.0;

        const totalPrice = Object.values(customProductBuilder_totalPriceSet).reduce((sum, value) => sum + value, 0);
        total.innerText = customProductBuilder_formatPrice(totalPrice * 100);
    }
    else {
        // remove from total
        customProductBuilder_totalPriceSet.logo = 0;

        const totalPrice = Object.values(customProductBuilder_totalPriceSet).reduce((sum, value) => sum + value, 0);
        total.innerText = customProductBuilder_formatPrice(totalPrice * 100);
    }
}

function customProductBuilder_formatPrice(price) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
}